<!--
//================================================================================
// ID:BC011C2
// ProjectName: 都営住宅募集オンライン申請
// SystemName: 都営住宅募集オンラインシステム
// JavaScriptName:BC011C2
//
// <<Modification History>>
// Version  | Date       | Updated By            | Content
// ---------+------------+-----------------------+--------------------------------
// 01.00.00 | 2021/09/14 | 富士通株式会社         | 新規作成
// 01.02.00 | 2022/10/03 | 富士通Japan株式会社	  | 令和4年度改修対応（2次リリース）
// 01.03.00 | 2023/02/13 | 富士通Japan株式会社    | 令和4年度改修対応（3次リリース）
// 01.04.00 | 2023/09/29 | 富士通Japan株式会社    | 令和5年度改修対応（3次リリース）
//================================================================================
-->
<template>
	<div class="contents__main contents__main--nyukyo">
		<error-message />
		<!-- 同居者注意文 -->
		<caution-message
			:tyuibunItems="disp.headerTyuiItems"
			:visibilityFlg="disp.cautionMsgVisibilityFlg"
		/>
		<br/>
		<h2 class="contents__h2">{{ disp.chapter }}</h2>
		<section>
			<table class="contents__table--stripe detail">
				<tbody>
					<tr class="contents__input--tr">
						<th class="contents__input--title border__bottom-none">
							氏名
						</th>
						<td class="border__bottom-none">
							<div id="contents--name__area">
								<div>
									氏：{{ nyukyosyaForm.nmName1 }}
								</div>
								<div>
									名：{{ nyukyosyaForm.nmName2 }}
								</div>
							</div>
						</td>
					</tr>
					<tr class="background__color--white">
						<th class="contents__input--title">
							フリガナ
						</th>
						<td>
							<div id="contents--name__area">
								<div>
									氏：{{ nyukyosyaForm.nmKana1 }}
								</div>
								<div>
									名：{{ nyukyosyaForm.nmKana2 }}
								</div>
							</div>
						</td>
					</tr>
					<tr class="contents__input--tr background__color--light-gray">
						<th class="contents__input--title">
							続柄
						</th>
						<td class="padding__top">
							<div>
								{{ nyukyosyaForm.nmTudukigara }}
							</div>
						</td>
					</tr>
					<tr class="contents__input--tr background__color--white">
						<th class="contents__input--title">
							生年月日
						</th>
						<td class="padding__top">
							<div>
								{{ co_editDate(nyukyosyaForm.dtBirthday) }}&nbsp;(満{{ co_calcAge(nyukyosyaForm.dtBirthday) }}歳)
							</div>
							<div v-if="formC2.bosyuHoshiki == BOSYU_HOSHIKI.ZUIJI">
								<caution-message
									:tyuibunItems="disp.birthdayTyuiItems2"
									:visibilityFlg="disp.cautionMsgVisibilityFlg"
								/>
							</div>
							<div v-else>
								<caution-message
									:tyuibunItems="disp.birthdayTyuiItems"
									:visibilityFlg="disp.cautionMsgVisibilityFlg"
								/>
							</div>
						</td>
					</tr>
					<tr class="contents__input--tr background__color--light-gray">
						<th class="contents__input--title">
							年間所得金額
						</th>
						<td class="padding__top">
							<div>
								{{ co_commaSeparated(nyukyosyaForm.moSyotoku) }}円
							</div>
							<caution-message
								:tyuibunItems="disp.syotokuItems"
								:visibilityFlg="disp.cautionMsgVisibilityFlg"
							/>
						</td>
					</tr>
					<tr class="contents__input--tr background__color--white">
						<th class="contents__input--title">特別控除</th>
						<td class="padding__top">
							<div class="height-kojto">
								<p class="p__multiple-row">
									{{ nyukyosyaForm.nmKojto }}
								</p>
							</div>
							<caution-message
								:tyuibunItems="disp.kojtoItems"
								:visibilityFlg="disp.cautionMsgVisibilityFlg"
							/>
						</td>
					</tr>
				</tbody>
			</table>
		</section>
		<div v-if="formC2.bosyuHoshiki == BOSYU_HOSHIKI.TEIKI_POINT">
			<br/>
			<div class="div-toggle-select-margin">
				<h2 class="contents__h2">身体障害者手帳の交付を受けていますか</h2>
				<div class="width-bekkyoUmu contents__toggle-nyukyo">
					{{ nyukyosyaForm.nmTecyo1Umu }}
				</div>
				<section v-if="nyukyosyaForm.kbTecyo1 == '1'">
					<table class="contents__table--stripe detail">
						<tbody>
							<tr class="contents__input--tr background__color--light-white">
								<th class="contents__input--title">
									等級等
								</th>
								<td class="padding__top">
									{{ nyukyosyaForm.nmTokyu1 }}
								</td>
							</tr>
							<tr class="contents__input--tr background__color--light-gray">
								<th class="contents__input--title">
									交付または更新年月日
								</th>
								<td class="padding__top">
									{{ co_editDate(nyukyosyaForm.dtKoufuKousin1) }}
								</td>
							</tr>
						</tbody>
					</table>
				</section>
			</div>
			<div class="div-toggle-select-margin">
				<h2 class="contents__h2">愛の手帳の交付を受けていますか</h2>
				<div class="width-bekkyoUmu contents__toggle-nyukyo">
					{{ nyukyosyaForm.nmTecyo2Umu }}
				</div>
				<section v-if="nyukyosyaForm.kbTecyo2 == '1'">
					<table class="contents__table--stripe detail">
						<tbody>
							<tr class="contents__input--tr background__color--light-white">
								<th class="contents__input--title">
									等級等
								</th>
								<td class="padding__top">
									{{ nyukyosyaForm.nmTokyu2 }}
								</td>
							</tr>
							<tr class="contents__input--tr background__color--light-gray">
								<th class="contents__input--title">
									交付または更新年月日
								</th>
								<td class="padding__top">
									{{ co_editDate(nyukyosyaForm.dtKoufuKousin2) }}
								</td>
							</tr>
						</tbody>
					</table>
				</section>
			</div>
			<div class="div-toggle-select-margin">
				<h2 class="contents__h2">精神障害者保健福祉手帳の交付を受けていますか</h2>
				<div class="width-bekkyoUmu contents__toggle-nyukyo">
					{{ nyukyosyaForm.nmTecyo3Umu }}
				</div>
				<section v-if="nyukyosyaForm.kbTecyo3 == '1'">
					<table class="contents__table--stripe detail">
						<tbody>
							<tr class="contents__input--tr background__color--light-white">
								<th class="contents__input--title">
									等級等
								</th>
								<td class="padding__top">
									{{ nyukyosyaForm.nmTokyu3 }}
								</td>
							</tr>
							<tr class="contents__input--tr background__color--light-gray">
								<th class="contents__input--title">
									交付または更新年月日
								</th>
								<td class="padding__top">
									{{ co_editDate(nyukyosyaForm.dtKoufuKousin3Stt) }}
								</td>
							</tr>
							<tr class="contents__input--tr background__color--light-white">
								<th class="contents__input--title">
									期限
								</th>
								<td class="padding__top">
									{{ co_editDate(nyukyosyaForm.dtKoufuKousin3End) }}
								</td>
							</tr>
						</tbody>
					</table>
				</section>
			</div>
			<div class="div-toggle-select-margin">
				<h2 class="contents__h2">障害年金の受給に関し、障害の程度が精神障害１級～３級と同程度であると判定されていますか</h2>
				<div class="width-bekkyoUmu contents__toggle-nyukyo">
					{{ nyukyosyaForm.nmTecyo4Umu }}
				</div>
				<section v-if="nyukyosyaForm.kbTecyo4 == '1'">
					<table class="contents__table--stripe detail">
						<tbody>
							<tr class="contents__input--tr background__color--light-white">
								<th class="contents__input--title">
									年金証書の障害等級
								</th>
								<td class="padding__top">
									{{ nyukyosyaForm.nmSyogaiTokyu }}
								</td>
							</tr>
							<tr class="contents__input--tr background__color--light-gray">
								<th class="contents__input--title">
									診断書の種類
								</th>
								<td class="padding__top">
									{{ nyukyosyaForm.nmSindanSyurui }}
								</td>
							</tr>
						</tbody>
					</table>
				</section>
			</div>
		</div>
		<div>
			<br v-if="formC2.bosyuHoshiki != BOSYU_HOSHIKI.TEIKI_POINT" />
			<h2 class="contents__h2">現在、申込者と同居していますか</h2>
			<div class="width-bekkyoUmu2">
				{{ nyukyosyaForm.nmBekkyoUmu }}
			</div>
			<div>
				<caution-message
					:classDiv="'padding-left15'"
					:cdHanyo1="'T0012'"
					:cdHanyo2="formC2.bosyuHoshiki"
					:visibilityFlg="disp.cautionMsgVisibilityFlg"
				/>
			</div>
			<br/>
			<section v-if="nyukyosyaForm.kbBekkyo == '2'">
				<table class="contents__table--stripe detail">
					<tbody>
						<tr class="contents__input--tr background__color--white">
							<th class="contents__input--title width-trans-title">住宅の種類</th>
							<td>
								<div class="width-trans-item">
									{{ nyukyosyaForm.nmBekkyoJyutaku }}
								</div>
								<div v-if="nyukyosyaForm.cdBekkyoJyutaku == '6' || nyukyosyaForm.cdBekkyoJyutaku == '13'">
									<caution-message
										:tyuibunItems="disp.zyutakuItems2"
									/>
								</div>
								<div v-else-if="(nyukyosyaForm.cdBekkyoJyutaku == '7' || nyukyosyaForm.cdBekkyoJyutaku == '8' || nyukyosyaForm.cdBekkyoJyutaku == '10' || 
												nyukyosyaForm.cdBekkyoJyutaku == '11' || nyukyosyaForm.cdBekkyoJyutaku == '12') && formC2.bosyuHoshiki != BOSYU_HOSHIKI.ZUIJI">
									<caution-message
										:tyuibunItems="disp.zyutakuItems3"
									/>
								</div>
							</td>
						</tr>
						<tr class="contents__input--tr background__color--light-gray">
							<th class="contents__input--title">都営住宅に入居する理由</th>
							<td>
								<p class="contents__textarea--display margin__top-5 margin__bottom-5" v-text="nyukyosyaForm.txNyukyoRiyu"/>
							</td>
						</tr>
					</tbody>
				</table>
			</section>
		</div>
		<br/>
		<h2 class="contents__h2">申込日時点の勤務先又は学校の名称・所在地</h2>
		<section>
			<table class="contents__table--stripe detail">
				<tbody>
					<tr class="contents__input--tr background__color--white">
						<th class="contents__input--title width-trans-title">所在地</th>
						<td>
							<div class="width-trans-item">
								{{ nyukyosyaForm.txSyozaichi }}
							</div>
						</td>
					</tr>
					<tr class="contents__input--tr background__color--light-gray">
						<th class="contents__input--title">名称</th>
						<td>
							<div>
								{{ nyukyosyaForm.txName }}
							</div>
						</td>
					</tr>
					<tr class="contents__input--tr background__color--white">
						<th class="contents__input--title">電話番号</th>
						<td>
							<div v-if="nyukyosyaForm.idTel1 != null">
								{{ nyukyosyaForm.idTel1 }}
								-
								{{ nyukyosyaForm.idTel2 }}
								-
								{{ nyukyosyaForm.idTel3 }}
							</div>
						</td>
					</tr>
					<tr class="contents__input--tr background__color--light-gray">
						<th class="contents__input--title width-senyoarea-title">勤務（開業）開始日</th>
						<td>
							<div class="width-senyoarea-item">
								{{ co_editDate(nyukyosyaForm.dtYmdStt) }}
							</div>
						</td>
					</tr>
					<tr class="contents__input--tr background__color--white">
						<th class="contents__input--title">職業</th>
						<td>
							<div>
								{{ nyukyosyaForm.nmSyokugyo }}
							</div>
						</td>
					</tr>
				</tbody>
			</table>
			<br/>
			<div class="contents__div--PC">
				<div id="contents__foot--button" class="contents__div--center margin__bottom-page">
					<div :class="[!disp.isPrevButton ? 'btn--prev-width' : '']" >
						<span v-if="disp.isPrevButton">
							<div id="btn--prev-pc">
								<input type="button" value="前の同居者" class="contents__btn--cancel btn--prev" tabindex="1" @click="prev"/>
							</div>
						</span>
					</div>
					<div class="btn-toroku">
						<input type="button" value="戻る" class="contents__btn--cancel btn--complete btn--back-width" tabindex="2" @click="back" ref="back"/>
					</div>
					<div :class="[!disp.isNextButton ? 'btn--next-width' : '']" >
						<span v-if="disp.isNextButton">
							<div id="btn--next-pc">
								<input type="button" value="次の同居者" class="contents__btn--confirm btn--next margin-right-0px" tabindex="3" @click="next"/>
							</div>
						</span>
					</div>
				</div>
			</div>
			<div class="contents__div--MOBILE">
				<div id="contents__foot--button" class="contents__div--center margin__bottom-page">
					<div :class="[!disp.isPrevButton ? 'btn--prev-width' : '']" >
						<a v-if="disp.isPrevButton" class="contents__btn--cancel btn--prev" tabindex="1" @click="prev">前の同居者</a>
					</div>
					<div class="btn-toroku">
						<a class="contents__btn--cancel btn--complete btn--back-width" tabindex="2" ref="back" @click="back">戻る</a>
					</div>
					<div :class="[!disp.isNextButton ? 'btn--next-width' : '']" >
						<a v-if="disp.isNextButton" class="contents__btn--confirm btn--next margin-right-0px" tabindex="3" @click="next">次の同居者</a>
					</div>
				</div>
			</div>
			<br/>
		</section>
	</div>
</template>

<script>
import ErrorMessage from '@/components/ErrorMessage.vue';
import CautionMessage from '@/components/CautionMessage.vue';

import { co_editDate, co_calcAge, co_commaSeparated, co_zenkaku2Hankaku } from '@/common/stringUtility.js';
import { co_isEmpty } from '@/common/checkUtility';
import { co_toTop } from '@/common/screenUtility.js';
import { BOSYU_HOSHIKI } from '@/const/const.js';
import { STORE_ERROR_CLEAR, STORE_VIEW_TITLE, STORE_DATA_GETDATA, STORE_DATA_DELETE_AT } from '@/const/store.js'

export default {
	name: "BC011C2",
	components: {
		'error-message': ErrorMessage,
		'caution-message' : CautionMessage,
	},
	data: function () {
		return {
			nyukyosyaForm: {
				noNyukyo: 0,			// 同居者番号
				nmName1: '',			// 氏名（氏）
				nmName2: '',			// 氏名（名）
				nmKana1: '',			// フリガナ（氏）
				nmKana2: '',			// フリガナ（名）
				cdTudukigara: '',		// 続柄
				nmTudukigara: '',		// 続柄（名称）
				dtBirthday: '',			// 生年月日
				kbGender: '', 			// 性別
				nmGender: '', 			// 性別（名称）
				moSyotoku: '',			// 年間所得
				fgKojto: '',			// 特別控除
				nmKojto: '',			// 特別控除（名称）
				nmTecyoKind: '',		// 手帳の種類（名称）
				nmTecyo1Umu: '',		// 手帳の種類所有有無名称（身体障害者手帳）
				nmTecyo2Umu: '',		// 手帳の種類所有有無名称（愛の手帳）
				nmTecyo3Umu: '',		// 手帳の種類所有有無名称（精神障害者保健福祉手帳）
				nmTecyo4Umu: '',		// 障害程度判定有無名称
				kbTecyo1: '',			// 同居者手帳の種類（身体障害者手帳）
				kbTecyo2: '',			// 同居者手帳の種類（愛の手帳）
				kbTecyo3: '',			// 同居者手帳の種類（精神障害者保健福祉手帳）
				kbTecyo4: '',			// 障害年金の判定有無
				cdTokyu1: '',			// 等級等（身体障害者手帳）
				nmTokyu1: '',			// 等級等名（身体障害者手帳）
				dtKoufuKousin1: '',		// 交付・更新年月日（身体障害者手帳）
				cdTokyu2: '',			// 等級等（愛の手帳）
				nmTokyu2: '',			// 等級等名（愛の手帳）
				dtKoufuKousin2: '',		// 交付・更新年月日（愛の手帳）
				cdTokyu3: '',			// 等級等（精神障害者保健福祉手帳）
				nmTokyu3: '',			// 等級等名（精神障害者保健福祉手帳）
				dtKoufuKousin3Stt: '',	// 交付・更新年月日（精神障害者保健福祉手帳）（自）
				dtKoufuKousin3End: '',	// 交付・更新年月日（精神障害者保健福祉手帳）（至）
				cdSyogaiTokyu: '',		// 年金証書の障害等級
				nmSyogaiTokyu: '',		// 年金証書の障害等級名
				cdSindanSyurui: '',		// 診断書の種類
				nmSindanSyurui: '',		// 診断書の種類名
				kbBekkyo: '',			// 別居有無区分
				cdBekkyoJyutaku: '',	// 同居住宅の種類
				nmBekkyoJyutaku: '',	// 同居住宅の種類（名称）
				txNyukyoRiyu: '',		// 同居者都営住宅に入居する理由
				txSyozaichi: '',		// 所在地
				txName: '',				// 名称
				idTel1: '',				// 電話番号（市外）
				idTel2: '',				// 電話番号（市内）
				idTel3: '',				// 電話番号（局番）
				dtYmdStt: '',			// 勤務（開業）開始日
				cdSyokugyo: '',			// 職業
				nmSyokugyo: '',			// 職業（名称）
				isInputCheck:false,		// 入力チェック結果
			},
			disp: {
				chapter: '',					// 見出し
				headerTyuiItems: ['C0028'],		// 同居者外国人注意文リスト
				tudukigaraTyuiItems: ['C0186'],	// 同居者続柄注意文リスト
				birthdayTyuiItems: ['C0191'],	// 同居者年齢注意文リスト
				birthdayTyuiItems2: ['C0223'],	// 同居者年齢注意文リスト2
				syotokuItems: ['C0034'],		// 年間所得注意文リスト
				kojtoItems: ['C0187'],			// 特別控除注意文リスト
				isPrevButton: true,				// 前の同居者ボタン表示フラグ
				isNextButton: true,				// 次の同居者ボタン表示フラグ
				cautionMsgVisibilityFlg: true,	// 注意文表示フラグ
				zyutakuItems2: ['C0026'],		// 住宅の種類注意文リスト2
				zyutakuItems3: ['C0025'],		// 住宅の種類注意文リスト3
			},
			formC2: [],		// 入力FORM
			co_editDate: co_editDate,
			co_calcAge: co_calcAge,
			co_commaSeparated: co_commaSeparated,
			co_isEmpty: co_isEmpty,
			BOSYU_HOSHIKI: BOSYU_HOSHIKI
		}
	},
	mounted: async function () {
	},
	created: async function() {

		// エラーをクリア
		this.$store.commit(STORE_ERROR_CLEAR);

		// 画面タイトル
		this.$store.commit(STORE_VIEW_TITLE, '同居者内容確認');

		// 画面項目設定
		this.formC2 = this.$store.getters[STORE_DATA_GETDATA]('BC011C2');
		let noNyukyo = Number(this.$route.params.noNyukyo);
		this.drawNyukyosyaInfo(noNyukyo);

		// パラメータ削除
		this.$store.commit(STORE_DATA_DELETE_AT, 'BC011C2');

		this.disp.cautionMsgVisibilityFlg = this.formC2.refChangebtn != '参照' ? true : false;
	},
	methods: {
		// 同居者情報設定
		drawNyukyosyaInfo: async function (noNyukyo) {

			// エラーをクリア
			this.$store.commit(STORE_ERROR_CLEAR);

			// 画面項目設定
			let nyukyoInfo = this.formC2.nyukyoList[noNyukyo-1];
			
			this.nyukyosyaForm = nyukyoInfo;
			this.nyukyosyaForm.noNyukyo = Number(noNyukyo);

			this.disp.chapter = '同居者情報（' + co_zenkaku2Hankaku(noNyukyo) + '人目・同居親族）　同居親族とは、申込者と一緒に都営住宅に入居する親族です。';

			if (noNyukyo == 1) {
				// 先頭同居者の場合、前の同居者ボタンを表示しない
				this.disp.isPrevButton = false;
			} else {
				this.disp.isPrevButton = true;
			}

			if (noNyukyo == this.formC2.nyukyoList.length) {
				// 最終同居者の場合、次の同居者ボタンを表示しない
				this.disp.isNextButton = false;
			} else {
				this.disp.isNextButton = true;
			}

			// ページトップへ遷移
			co_toTop();
		},
		// 前の同居者ボタン
		prev: async function () {

			// 同居者内容確認画面（前の同居者）に遷移
			this.drawNyukyosyaInfo(this.nyukyosyaForm.noNyukyo - 1);
		},
		// 戻るボタン
		back: function () {
			
			// 申込み内容確認画面に遷移
			this.$emit('back', this.formC2.nyukyoList.length);
		},
		// 次の同居者ボタン
		next: async function () {

			// 同居者内容確認画面（次の同居者）に遷移
			this.drawNyukyosyaInfo(this.nyukyosyaForm.noNyukyo + 1);
		}
	}
};
</script>

<style scoped>

.height-kojto {
	height: 25px;
	margin-top: 10px;
	padding-bottom: 13px;
}

th {
	margin-bottom: -18px;
}

.width-bekkyoUmu { 
	margin-left: 15px;
}

.width-bekkyoUmu2 {
	margin-top: 15px; 
	margin-left: 15px;
}

.contents__toggle-nyukyo {
	margin-top: 15px !important;
	margin-bottom: 15px !important;
}

.div-toggle-select-margin {
	margin-top: 10px;
	margin-bottom: 20px;
}

.padding-left15 {
	padding-left: 15px;
}

/* 端末がPCの場合 */
@media screen and (min-width: 768px) {
	.contents__main--nyukyo {
		margin-top: 80px !important;
	}

	/* フッターボタン */
	#contents__foot--button {
		display: flex;
		flex-direction: row;
	}
	#contents__foot--button :nth-child(1) {
		order: 1;
		text-align: left;
	}
	#contents__foot--button :nth-child(2) {
		order: 2;
		margin: auto;
		text-align: center;
	}
	#contents__foot--button :nth-child(3) {
		order: 3;
		text-align: right;
	}

	.btn--prev-width,
	.btn--next-width {
		width: 8%;
	}

	.padding__top {
		padding-top: 10px !important;
	}
}

/* 端末がスマホの場合 */
@media screen and (max-width: 767px) {
	.contents__main--nyukyo {
		margin-top: 15px !important;
	}

	/* フッターボタン */
	#contents__foot--button {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
	}
	#contents__foot--button :nth-child(1) {
		order: 1;
		width: 50%;
		margin-bottom: 1%;
		text-align: center;
	}
	#contents__foot--button :nth-child(2) {
		order: 3;
		width: 100%;
		text-align: center;
	}
	#contents__foot--button :nth-child(3) {
		order: 2;
		width: 50%;
		margin-bottom: 1%;
		text-align: center;
	}

	.padding__top {
		padding-top: 0px !important;
	}

	.margin-right-0px {
		margin-right: 0px !important;
	}
}
</style>